import { useState, useCallback } from 'react';

import envConfig from 'services/env-config';

export interface UseComposerNXFlowReturn {
    showIntro: boolean;
    suppressModal: boolean;
    closeModals: () => void;
    handleTryComposerNX: () => void;
    handleOpenAampeNX: () => void;
    goBack: () => void;
}

/**
 * Hook for managing the Composer NX.0 modal flow
 */
export const useComposerNXFlow = (): UseComposerNXFlowReturn => {
    const [showIntro, setShowIntro] = useState(false);
    const [suppressModal, setSuppressModal] = useState(false);

    const closeModals = () => {
        setShowIntro(false);
    };

    const handleTryComposerNX = useCallback(() => {
        // Show intro modal
        setShowIntro(true);
    }, []);

    const handleOpenAampeNX = useCallback(() => {
        // Suppress modal from showing again
        setSuppressModal(true);

        // Close modals
        closeModals();

        // Navigate to Next.js app with parameters
        const currentUrl = window.location.href;
        const nextAppUrl = `${
            envConfig.COMPOSER_FRONTEND_NEXT_API
        }/workflows/new/canvas?returnTo=${encodeURIComponent(currentUrl)}`;

        // Navigate in same tab for proper session handling
        window.location.href = nextAppUrl;
    }, [closeModals]);

    const goBack = useCallback(() => {
        closeModals();
    }, [closeModals]);

    return {
        showIntro,
        suppressModal,
        closeModals,
        handleTryComposerNX,
        handleOpenAampeNX,
        goBack,
    };
};
